import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import { Location } from "@reach/router"
import React from "react"
import { LiveChatLoaderProvider } from "react-live-chat-loader"
import { CookieProvider } from "./src/providers/CookieProvider"
import { StoreProvider } from "./src/providers/StoreProvider"
import { UserProvider } from "./src/providers/UserProvider"

Bugsnag.start({
  apiKey: process.env.GATSBY_APP_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.CONTEXT || process.env.NODE_ENV,
  appVersion: process.env.DEPLOY_ID,
})

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React)

export const wrapRootElement = ({ element }) => {
  return (
    <ErrorBoundary>
      <Location>
        {context => {
          return (
            <StoreProvider>
              <UserProvider>
                <CookieProvider>
                  <LiveChatLoaderProvider
                    providerKey="unl8h2cn"
                    provider="intercom"
                  >
                    {element}
                  </LiveChatLoaderProvider>
                </CookieProvider>
              </UserProvider>
            </StoreProvider>
          )
        }}
      </Location>
    </ErrorBoundary>
  )
}
